import React from "react";

const User = props => (
  <svg
    viewBox="0 0 17 21"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="0.5em"
    height="1em"
    {...props}
  >
    <defs>
      <path
        d="M25.457 18.164l-3.346-3.346a7.446 7.446 0 0 1 3.39-.818c1.196 0 2.325.29 3.33.79l-3.374 3.374zM25.5 13c-4.687 0-8.5 3.813-8.5 8.5a.5.5 0 0 0 1 0 7.49 7.49 0 0 1 3.225-6.154l4.232 4.232 4.268-4.268A7.493 7.493 0 0 1 33 21.5a.5.5 0 0 0 1 0c0-4.687-3.813-8.5-8.5-8.5zm0-11c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4zm0 9a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"
        id="user-a"
      />
    </defs>
    <g transform="translate(-17 -1)" fillRule="evenodd">
      <mask id="user-b">
        <use xlinkHref="#user-a" />
      </mask>
      <use xlinkHref="#user-a" />
      <g mask="url(#user-b)">
        <path d="M0 0h50v25H0z" />
      </g>
    </g>
  </svg>
);

export default User;


// WEBPACK FOOTER //
// ./src/components/icons/User.js